if (!process.env.NEXT_PUBLIC_URL)
  throw new Error('Environment variable NEXT_PUBLIC_URL is not defined')

const siteOrigin = new URL(process.env.NEXT_PUBLIC_URL ?? '')

export const isExternalUrl = (url: string) => {
  const currentURL = new URL(url, siteOrigin)
  return currentURL.hostname !== siteOrigin.hostname
}
